var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfiliationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.75L11.375 0.25C11.25 0.125 11.125 0 11 0H4.375C3.75 0 3.125 0.25 2.625 0.75C2.125 1.25 1.875 1.875 1.875 2.5V17.5C1.875 18.125 2.125 18.875 2.625 19.25C3.125 19.75 3.75 20 4.375 20H15.625C16.25 20 17 19.75 17.375 19.25C17.875 18.75 18.125 18.125 18.125 17.5V7.25C18.125 7 18.125 6.875 18 6.75ZM11.625 2.25L15.875 6.5H11.625V2.25ZM16.75 17.5C16.75 17.875 16.625 18.125 16.375 18.375C16.125 18.625 15.875 18.75 15.5 18.75H4.25C3.875 18.75 3.625 18.625 3.375 18.375C3.125 18.125 3 17.875 3 17.5V2.5C3 2.125 3.125 1.875 3.375 1.625C3.75 1.5 4.125 1.375 4.375 1.375H10.25V7.25C10.25 7.625 10.5 7.875 10.875 7.875H16.75V17.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 11.25C4.875 10.875 5.25 10.5 5.625 10.5H14.375C14.75 10.5 15.125 10.875 15.125 11.25C15.125 11.625 14.75 12 14.375 12H5.625C5.25 12 4.875 11.625 4.875 11.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 15C4.875 14.625 5.25 14.25 5.625 14.25H14.375C14.75 14.25 15.125 14.625 15.125 15C15.125 15.375 14.75 15.75 14.375 15.75H5.625C5.25 15.75 4.875 15.375 4.875 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfiliationsIcon);
export default __webpack_public_path__ + "static/media/afiliationsIcon.bd689a2aae79efca29fb4664e8e1fb1f.svg";
export { ForwardRef as ReactComponent };